import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { SalesRedirectionButtonInterface } from 'common/types/entities/button-interface'
import EntityInterface from 'common/types/entities/EntityInterface'
import React from 'react'
import createCommonEntitySettings from '../createCommonEntitySettings'
import SalesRedirectionButtonSettings from './settings/SalesRedirectionButtonSettings'

function createSettingsForSales(
  entity: EntityInterface,
  defaultEntity?: EntityInterface,
) {
  switch (entity.type) {
    case EntityTypeEnum.SalesRedirectionButton:
      return (
        <SalesRedirectionButtonSettings
          entity={entity as SalesRedirectionButtonInterface}
          defaultEntity={defaultEntity as SalesRedirectionButtonInterface}
        />
      )
    default:
      return createCommonEntitySettings(entity, defaultEntity)
  }
}

export default createSettingsForSales
